import Cookies from 'js-cookie';
import { useEffect } from 'react';

const webViewRegex = /CarvanaNativeWebView/gi;
const androidRegex = /Android/gi;
const minimumAndroidVersion = '5.20.2';
const minimumIOSVersion = '5.39.0';

const isWebView = () => {
  const ua = navigator?.userAgent;

  return webViewRegex.test(ua);
};

const isAndroid = () => {
  return androidRegex.test(navigator?.userAgent);
};

const supportedByVersion = (
  currentVersion: string,
  supportedVersion: string
) => {
  const [
    currentMajor = 0,
    currentMinor = 0,
    currentPatch = 0
  ] = currentVersion.split('.').map(v => Number.parseInt(v));
  const [
    supportedMajor = 0,
    supportedMinor = 0,
    supportedPatch = 0
  ] = supportedVersion.split('.').map(v => Number.parseInt(v));

  if (currentMajor > supportedMajor) return true;
  if (currentMajor === supportedMajor && currentMinor > supportedMinor)
    return true;
  if (
    currentMajor === supportedMajor &&
    currentMinor === supportedMinor &&
    currentPatch >= supportedPatch
  )
    return true;
  return false;
};

const hasNewWebViewSupport = () => {
  if (!isWebView()) {
    return false;
  }

  const appVersion = Cookies.get('X-CVNA-AppVersion') || '0.0.0';
  const supportedVersion = isAndroid()
    ? minimumAndroidVersion
    : minimumIOSVersion;

  return supportedByVersion(appVersion, supportedVersion);
};

const isAtNewWebViews = () => {
  return window.location.pathname.startsWith('/purchase-steps');
};

const useWebViewRedirect = () => {
  useEffect(() => {
    if (hasNewWebViewSupport() && !isAtNewWebViews()) {
      const [
        ignoredEmptyInitial,
        ignoredBasename,
        ...restOfPath
      ] = window.location.pathname.split('/');
      const newPath = `/purchase-steps/${restOfPath.join('/')}`;
      window.location.href = newPath;
    }
  }, []);
};

export default useWebViewRedirect;
